// removed by extract-text-webpack-plugin
module.exports = {"form":"c-CheckoutForm__form"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/CheckoutForm/CheckoutForm.scss
// module id = 450
// module chunks = 0